import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { CardAction } from './card-action';

/**
 * Card action component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { CardActionModule } from 'patternfly-ng/card';
 * // Or
 * import { CardActionModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [CardActionModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { CardAction } from 'patternfly-ng/card';
 * </pre></code>
 */

export class CardActionComponent implements OnInit {
  /**
   * The card filters
   */
   action: CardAction;

  /**
   * The event emitted when a filter is selected
   */
   onActionSelect = new EventEmitter();

  /**
   * The default constructor
   */
  constructor() {
  }

  // Initialization

  /**
   * Setup component configuration upon initialization
   */
  ngOnInit(): void {
  }

  // Actions

  private select($event: MouseEvent): void {
    this.onActionSelect.emit(this.action);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-card-action',
  template: `<div *ngIf="action === undefined || action?.disabled; then showDisabled else showEnabled"></div><ng-template #showDisabled><span class="{{action?.iconStyleClass}} card-pf-footer-text" *ngIf="action?.iconStyleClass" [ngClass]="{'card-pf-link-with-icon': action?.iconStyleClass, 'card-pf-link': !action?.iconStyleClass}"></span> <span class="card-pf-footer-text" *ngIf="action?.hypertext">{{action?.hypertext}}</span></ng-template><ng-template #showEnabled><a href="{{action?.url}}" *ngIf="action?.url" [ngClass]="{'card-pf-link-with-icon': action?.iconStyleClass, 'card-pf-link': !action?.iconStyleClass}"><span class="{{action?.iconStyleClass}} card-pf-footer-text" *ngIf="action?.iconStyleClass"></span> <span class="card-pf-footer-text" *ngIf="action?.hypertext">{{action?.hypertext}}</span> </a><a *ngIf="!action?.url" [ngClass]="{'card-pf-link-with-icon': action?.iconStyleClass, 'card-pf-link': !action?.iconStyleClass}" (click)="select($event)"><span class="{{action?.iconStyleClass}} card-pf-footer-text" *ngIf="action?.iconStyleClass"></span> <span class="card-pf-footer-text" *ngIf="action?.hypertext">{{action?.hypertext}}</span></a></ng-template>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'action': [{ type: Input },],
'onActionSelect': [{ type: Output, args: ['onActionSelect', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
